import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Spectrumservices({ handleShow }) {
  return (
    <section className="spectrum_services p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={11}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>Our Comprehensive Mobile App Development Services in the UK</h2>
            <p>
              We are a data-driven{" "}
              <Link to="/uk/mobile-app-development-company-uk">
                app development firm
              </Link>{" "}
              specialising in custom iOS, Android, and React Native hybrid apps.
              Our mobile app developers in the UK collaborate with startups and
              established brands, delivering transparent, bespoke solutions. We
              provide full-spectrum mobile app development services in the UK,
              ensuring high-end communication and showcasing your brand's
              values.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="spec_services_box">
              <div className="spec_services_item">
                <div className="spec_services_img">
                  <StaticImage
                    src="../../../images/location_new/uk-mobile/services/android.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={69}
                    height={69}
                  />
                </div>
                <div className="spec_services_head">
                  <h5>
                    Android
                    <br />
                    App Development
                  </h5>
                </div>
              </div>
              <p>
                Our skilled Android developers give your app ideas a tangible
                form. From intuitive UI/UX design to robust functionality, we
                create Android apps in the UK that resonate with your target
                audience.
              </p>
              <Link
                to="/android-app-development"
                className="spec_btn"
                aria-label="TekRevol Contact"
              >
                Get Android App Developed
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="spec_services_box">
              <div className="spec_services_item">
                <div className="spec_services_img">
                  <StaticImage
                    src="../../../images/location_new/uk-mobile/services/apple.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={69}
                    height={69}
                  />
                </div>
                <div className="spec_services_head">
                  <h5>
                    iPhone App
                    <br /> Development
                  </h5>
                </div>
              </div>
              <p>
                Conquer the iOS ecosystem with our iPhone app development
                services in the UK. We understand the intricacies and
                capabilities of Apple’s platform, and we ensure seamless
                performance, elegant design, and adherence to App Store
                guidelines.
              </p>
              <Link
                to="/iphone-app-development"
                className="spec_btn"
                aria-label="TekRevol Contact"
              >
                Get iPhone App Developed
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="spec_services_box">
              <div className="spec_services_item">
                <div className="spec_services_img">
                  <StaticImage
                    src="../../../images/location_new/uk-mobile/services/react_native.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={69}
                    height={69}
                  />
                </div>
                <div className="spec_services_head">
                  <h5>
                    React Native App
                    <br /> Development
                  </h5>
                </div>
              </div>
              <p>
                React Native bridges the gap between native and cross-platform
                development. Our React Native experts in the UK create apps that
                combine the best of both worlds—native performance and code
                reusability without compromising on quality.
              </p>
              <Link
                to="/react-native-app-development"
                className="spec_btn"
                aria-label="TekRevol Contact"
              >
                Get React Native App Development
              </Link>
            </div>
          </Col>

          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="spec_services_box">
              <div className="spec_services_item">
                <div className="spec_services_img">
                  <StaticImage
                    src="../../../images/location_new/uk-mobile/services/flutter.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={64}
                    height={66}
                  />
                </div>
                <div className="spec_services_head">
                  <h5>
                    Flutter App
                    <br /> Development
                  </h5>
                </div>
              </div>
              <p>
                Flutter, Google’s UI toolkit, empowers us to build natively
                compiled apps for multiple platforms from a single codebase.
                Whether you need a dynamic mobile app or a web application, our
                Flutter expertise ensures a consistent experience across
                devices.
              </p>
              <Link
                to="/flutter-app-development"
                className="spec_btn"
                aria-label="TekRevol Contact"
              >
                Get Flutter App Development
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="spec_services_box">
              <div className="spec_services_item">
                <div className="spec_services_img">
                  <StaticImage
                    src="../../../images/location_new/uk-mobile/services/PWA.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={69}
                    height={69}
                  />
                </div>
                <div className="spec_services_head">
                  <h5>
                    Progressive Web
                    <br /> Apps (PWAs)
                  </h5>
                </div>
              </div>
              <p>
                PWAs offer the best of web and app experiences. These
                lightweight, responsive applications work seamlessly across all
                devices. They are a cheaper option best for validating your app
                idea by getting it to the market quickly and cost-effectively.
              </p>
              <button
                onClick={handleShow}
                className="spec_btn"
                aria-label="TekRevol Contact"
              >
                Get PWA Development
              </button>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="spec_services_box">
              <div className="spec_services_item">
                <div className="spec_services_img">
                  <StaticImage
                    src="../../../images/location_new/uk-mobile/services/hybrid.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={65}
                    height={68}
                  />
                </div>
                <div className="spec_services_head">
                  <h5>
                    Hybrid App
                    <br /> Development
                  </h5>
                </div>
              </div>
              <p>
                Hybrid apps blend native and web technologies. With frameworks
                like Ionic and Cordova, our app developers in the UK
                deliverbespoke applications that run on both iOS and Android.
                Get the best of both platforms without doubling development
                efforts.
              </p>
              <button
                className="spec_btn"
                onClick={handleShow}
                aria-label="TekRevol Contact"
              >
                Get Hybrid App Development
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Spectrumservices;
